import React from "react";
import * as R from "ramda";

import { Form, Checkbox } from "antd";

const NullableCheckboxFormItem = ({ label, options, ...otherProps }) => {
    if (R.isNil(options) || R.isEmpty(options)) {
        return null;
    }

    return (
        <Form.Item label={label}>
            <Checkbox.Group {...otherProps} options={options} />
        </Form.Item>
    );
};

export default NullableCheckboxFormItem;
